import { generateKeys } from '../utils';
export const forexCommands = generateKeys({
    buy: {
        value: 0,
        label: 'Buy',
    },
    sell: {
        value: 1,
        label: 'Sell',
    },
    buyLimit: {
        value: 2,
        label: 'Buy Limit',
    },
    sellLimit: {
        value: 3,
        label: 'Sell Limit',
    },
    buyStop: {
        value: 4,
        label: 'Buy Stop',
    },
    sellStop: {
        value: 5,
        label: 'Sell Stop',
    },
    balance: {
        value: 6,
        label: 'Balance',
    },
    credit: {
        value: 7,
        label: 'Credit',
    },
});
export const cuboidAssetMap = generateKeys({
    1: {
        symbol: 'AUD/CAD',
        label: 'AUD/CAD',
        group: 'Currencies',
    },
    2: {
        symbol: 'GBP/JPY',
        label: 'GBP/JPY',
        group: 'Currencies',
    },
    3: {
        symbol: 'AUD/USD',
        label: 'AUD/USD',
        group: 'Currencies',
    },
    4: {
        symbol: 'EUR/CHF',
        label: 'EUR/CHF',
        group: 'Currencies',
    },
    5: {
        symbol: 'EUR/GBP',
        label: 'EUR/GBP',
        group: 'Currencies',
    },
    6: {
        symbol: 'EUR/AUD',
        label: 'EUR/AUD',
        group: 'Currencies',
    },
    7: {
        symbol: 'EUR/JPY',
        label: 'EUR/JPY',
        group: 'Currencies',
    },
    8: {
        symbol: 'GBP/CHF',
        label: 'GBP/CHF',
        group: 'Currencies',
    },
    9: {
        symbol: 'EUR/USD',
        label: 'EUR/USD',
        group: 'Currencies',
    },
    10: {
        symbol: 'USD/CAD',
        label: 'USD/CAD',
        group: 'Currencies',
    },
    11: {
        symbol: 'NZD/USD',
        label: 'NZD/USD',
        group: 'Currencies',
    },
    12: {
        symbol: 'USD/CHF',
        label: 'USD/CHF',
        group: 'Currencies',
    },
    13: {
        symbol: 'GBP/USD',
        label: 'GBP/USD',
        group: 'Currencies',
    },
    14: {
        symbol: 'CHF/JPY',
        label: 'CHF/JPY',
        group: 'Currencies',
    },
    15: {
        symbol: 'AUD/JPY',
        label: 'AUD/JPY',
        group: 'Currencies',
    },
    16: {
        symbol: 'AUD/NZD',
        label: 'AUD/NZD',
        group: 'Currencies',
    },
    17: {
        symbol: 'USD/JPY',
        label: 'USD/JPY',
        group: 'Currencies',
    },
    18: {
        symbol: 'EUR/CAD',
        label: 'EUR/CAD',
        group: 'Currencies',
    },
    19: {
        symbol: 'USD/CNH',
        label: 'USD/CNH',
        group: 'Currencies',
    },
    20: {
        symbol: 'UK100X',
        label: 'FTSE',
        group: 'Indices',
    },
    21: {
        symbol: 'US500X',
        label: 'S&P 500',
        group: 'Indices',
    },
    22: {
        symbol: 'US30X',
        label: 'Dow Jones 30',
        group: 'Indices',
    },
    23: {
        symbol: 'HKG33',
        label: 'Hang Seng 33',
        group: 'Indices',
    },
    24: {
        symbol: 'AUS200X',
        label: 'ASX/S&P 200',
        group: 'Indices',
    },
    25: {
        symbol: 'JPN225',
        label: 'Nikkei 225',
        group: 'Indices',
    },
    26: {
        symbol: 'GER30',
        label: 'DAX 30',
        group: 'Indices',
    },
    27: {
        symbol: 'NAS100',
        label: 'NASDAQ 100',
        group: 'Indices',
    },
    31: {
        symbol: 'ITA40',
        label: 'Italian Index',
        group: 'Indices',
    },
    32: {
        symbol: 'FRA40',
        label: 'French Index',
        group: 'Indices',
    },
    33: {
        symbol: 'ESP35',
        label: 'Spanish Index',
        group: 'Indices',
    },
    35: {
        symbol: 'EUSTX50',
        label: 'Euro Stoxx 50',
        group: 'Indices',
    },
    36: {
        symbol: 'XAUUSD',
        label: 'Gold',
        group: 'Commodities',
    },
    37: {
        symbol: 'XAGUSD',
        label: 'Silver',
        group: 'Commodities',
    },
    38: {
        symbol: 'USOUSD',
        label: 'USOil',
        group: 'Commodities',
    },
    39: {
        symbol: 'UKOUSD',
        label: 'UKOil',
        group: 'Commodities',
    },
    40: {
        symbol: 'NGAS',
        label: 'Natural Gas',
        group: 'Commodities',
    },
    901: {
        symbol: 'Fear',
        label: 'Fear',
        group: 'Sentiments',
    },
    902: {
        symbol: 'Greed',
        label: 'Greed',
        group: 'Sentiments',
    },
    903: {
        symbol: 'Fear&Greed',
        label: 'Fear&Greed',
        group: 'Sentiments',
    },
});
